<template>
    <div class="section_in privacy-policy">
        <div class="offset-top-40">
            <h6 class="privacy-policy_list_title text-bold">
                I. Dane Administratora Danych Osobowych
            </h6>
            <p class="privacy-policy_list_item">
                Uprzejmie informujemy, że administratorem Pana/Pani danych
                osobowych jest Novakid Inc US 548 Market St 8291, San Francisco,
                CA 94104-5401, +1 (408) 757 0081, zwany dalej „Novakid".
            </p>
        </div>
        <div class="offset-top-40">
            <h6 class="privacy-policy_list_title text-bold">
                II. Dane kontaktowe
            </h6>
            <p class="privacy-policy_list_item">
                Kontakt z Novakid w sprawie ochrony danych osobowych jest
                możliwy pod adresem e-mail: bok@novakid.pl, a także pod numerem
                telefonu +48223906433. Novakid nie posiada Inspektora Ochrony
                Danych.
            </p>
        </div>
        <div class="offset-top-40">
            <h6 class="privacy-policy_list_title text-bold">
                III. Cele i podstawy przetwarzania danych osobowych
            </h6>
            <p class="privacy-policy_list_item">
                Aby świadczyć usługi zgodnie z profilem działalności, Novakid
                przetwarza Pana/Pani dane osobowe — w różnych celach, jednak
                zawsze zgodnie z prawem. Poniżej znajdzie Pan/Pani
                wyszczególnione cele przetwarzania danych osobowych wraz z
                podstawami prawnymi
            </p>
        </div>
        <div class="offset-top-30">
            <p class="privacy-policy_list_item">
                W celu umożliwienia skontaktowania się z nami poprzez formularz
                kontaktowy przetwarzamy takie dane osobowe, jak:
            </p>
            <ul>
                <li>imię i nazwisko (jeżeli zostanie podane),</li>
                <li>adres e-mail,</li>
                <li>numer telefonu,</li>
            </ul>
            <p class="privacy-policy_list_item">
                Podstawą prawną takiego przetwarzania danych jest art. 6 ust. 1
                lit. b RODO, który pozwala przetwarzać dane osobowe, jeżeli są
                one konieczne do wykonania umowy lub podjęcia czynności
                zmierzających do zawarcia umowy; jeżeli zdecyduje się Pan/Pani
                podać również nazwisko, uznajemy, że wyraził(a) Pan/Pani zgodę
                na przetwarzanie również Pana/Pani nazwiska — wtedy podstawą
                prawną takiego przetwarzania jest art. 6 ust. 1 lit. a RODO,
                który pozwala przetwarzać dane osobowe na podstawie dobrowolnie
                udzielonej zgody;
            </p>
        </div>
        <div class="offset-top-30">
            <p class="privacy-policy_list_item">
                W celu zawarcia umowy i wykonania usługi (płatnej oraz
                bezpłatnej) przetwarzamy takie dane osobowe, jak:
            </p>
            <ul>
                <li>imię i nazwisko (jeżeli zostanie podane),</li>
                <li>adres e-mail,</li>
                <li>numer telefonu,</li>
                <li>imię dziecka,</li>
                <li>wiek dziecka,</li>
            </ul>
            <p class="privacy-policy_list_item">
                Podstawą prawną takiego przetwarzania danych jest art. 6 ust. 1
                lit. b RODO, który pozwala przetwarzać dane osobowe, jeżeli są
                one konieczne do wykonania umowy lub podjęcia czynności
                zmierzających do zawarcia umowy; jeżeli zdecyduje się Pan/Pani
                podać również nazwisko, uznajemy, że wyraził(a) Pan/Pani zgodę
                na przetwarzanie również Pana/Pani nazwiska — wtedy podstawą
                prawną takiego przetwarzania jest art. 6 ust. 1 lit. a RODO,
                który pozwala przetwarzać dane osobowe na podstawie dobrowolnie
                udzielonej zgody;
            </p>
            <p class="privacy-policy_list_item">jak również:</p>
            <ul>
                <li>wizerunek rodzica,</li>
                <li>wizerunek dziecka,</li>
            </ul>
            <p class="privacy-policy_list_item">
                Podstawą prawną takiego przetwarzania danych jest art. 9 ust. 2
                lit. a RODO, który pozwala przetwarzać dane osobowe, które
                mogłyby ujawnić pochodzenie rasowe lub etniczne, jeżeli wyraził
                Pan/Pani wyraźną zgodę na ich przetwarzanie w konkretnym celu.
                Powyższą zgodę jest odbierana w trakcie zakładania konta na
                stronie www.novakid.pl
            </p>
        </div>
        <div class="offset-top-30">
            <p class="privacy-policy_list_item">
                W celu rozpatrzenia reklamacji przetwarzamy takie dane osobowe,
                jak:
            </p>
            <ul>
                <li>imię i nazwisko (jeżeli zostanie podane),</li>
                <li>adres e-mail,</li>
                <li>
                    ewentualnie adres zamieszkania — jeżeli następuje zwrot
                    pieniędzy,
                </li>
                <li>
                    ewentualnie numer rachunku bankowego — jeżeli następuje
                    zwrot pieniędzy,
                </li>
            </ul>
            <p class="privacy-policy_list_item">
                Podstawą prawną takiego przetwarzania danych jest art. 6 ust. 1
                lit. b RODO, który pozwala przetwarzać dane osobowe, jeżeli są
                one konieczne do wykonania umowy lub podjęcia czynności
                zmierzających do zawarcia umowy; jeżeli zdecyduje się Pan/Pani
                podać również nazwisko, uznajemy, że wyraził(a) Pan/Pani zgodę
                na przetwarzanie również Pana/Pani nazwiska — wtedy podstawą
                prawną takiego przetwarzania jest art. 6 ust. 1 lit. a RODO,
                który pozwala przetwarzać dane osobowe na podstawie dobrowolnie
                udzielonej zgody;
            </p>
            <p class="privacy-policy_list_item">jak również:</p>
            <ul>
                <li>wizerunek rodzica,</li>
                <li>wizerunek dziecka,</li>
            </ul>
            <p class="privacy-policy_list_item">
                Podstawą prawną takiego przetwarzania danych jest art. 9 ust. 2
                lit. a RODO, który pozwala przetwarzać dane osobowe, które
                mogłyby ujawnić pochodzenie rasowe lub etniczne, jeżeli osoba,
                której dane dotyczą, wyraziła wyraźną zgodę na ich
                przetwarzanie.
            </p>
        </div>
        <div class="offset-top-30">
            <p class="privacy-policy_list_item">
                W celu przesyłania powiadomień e-mail oraz sms o komunikatach w
                panelu klienta przetwarzamy takie dane osobowe, jak:
            </p>
            <ul>
                <li>adres e-mail,</li>
                <li>numer telefonu.</li>
            </ul>
            <p class="privacy-policy_list_item">
                Podstawą prawną takiego przetwarzania danych jest art. 6 ust. 1
                lit. f RODO, który pozwala przetwarzać dane osobowe, jeżeli tym
                sposobem Administrator Danych Osobowych realizuje swój prawnie
                uzasadniony interes (w tym przypadku interesem Novakid jest
                informowanie klienta o czynnościach związanych z realizacją
                usługi w celu podwyższenia komfortu korzystania z serwisu);
            </p>
        </div>
        <div class="offset-top-30">
            <p class="privacy-policy_list_item">
                W celu kontaktu telefonicznego w sprawach związanych z
                realizacją usługi przetwarzamy takie dane osobowe, jak:
            </p>
            <ul>
                <li>numer telefonu,</li>
                <li>imię,</li>
            </ul>
            <p class="privacy-policy_list_item">
                Podstawą prawną takiego przetwarzania danych jest art. 6 ust. 1
                lit. f RODO, który pozwala przetwarzać dane osobowe, jeżeli tym
                sposobem Administrator Danych Osobowych realizuje swój prawnie
                uzasadniony interes (w tym przypadku interesem Novakid jest
                informowanie klienta o czynnościach związanych z realizacją
                usługi w celu podwyższenia komfortu korzystania z serwisu);
            </p>
        </div>
        <div class="offset top-30">
            <p class="privacy-policy_list_item">
                W celu wystawienia faktury i spełnienia innych obowiązków
                wynikających z przepisów prawa podatkowego, takich jak np.
                przechowywanie dokumentacji księgowej, przetwarzamy takie dane
                osobowe, jak:
            </p>
            <ul>
                <li>imię i nazwisko,</li>
                <li>firma,</li>
                <li>adres zamieszkania lub adres siedziby,</li>
                <li>numer NIP,</li>
            </ul>
            <p class="privacy-policy_list_item">
                Podstawą prawną takiego przetwarzania danych jest art. 6 ust. 1
                lit. c RODO, który pozwala przetwarzać dane osobowe, jeżeli
                takie przetwarzanie jest konieczne do wywiązania się przez
                Administratora Danych Osobowych z obowiązków wynikających z
                prawa;
            </p>
        </div>
        <div class="offset-top-30">
            <p class="privacy-policy_list_item">
                W celu badania satysfakcji z oferowanych usług przetwarzamy
                takie dane osobowe, jak:
            </p>
            <ul>
                <li>imię,</li>
                <li>adres e-mail,</li>
                <li>numer telefonu.</li>
            </ul>
            <p class="privacy-policy_list_item">
                Podstawą prawną takiego przetwarzania danych jest art. 6 ust. 1
                lit. f RODO, który pozwala przetwarzać dane osobowe, jeżeli tym
                sposobem Administrator Danych Osobowych realizuje swój prawnie
                uzasadniony interes (w tym przypadku interesem Novakid jest
                poznanie opinii klientów na temat świadczonych usług, aby
                dostosować je do potrzeb i oczekiwań zainteresowanych);
            </p>
        </div>
        <div class="offset-top-30">
            <p class="privacy-policy_list_item">
                W celu tworzenia rejestrów i ewidencji związanych z RODO, w tym
                np. rejestru klientów, którzy zgłosili sprzeciw zgodnie z RODO,
                przetwarzamy takie dane osobowe, jak:
            </p>
            <ul>
                <li>imię,</li>
                <li>adres e-mail,</li>
            </ul>
            <p class="privacy-policy_list_item">
                ponieważ przepisy RODO nakładają na nas określone obowiązki
                dokumentacyjne dla wykazania zgodności i rozliczalności,
            </p>
            <p class="privacy-policy_list_item">
                Podstawą prawną takiego przetwarzania danych jest art. 6 ust. 1
                lit. c RODO, który pozwala przetwarzać dane osobowe, jeżeli
                takie przetwarzanie jest konieczne do wywiązania się przez
                Administratora Danych Osobowych z obowiązków wynikających z
                prawa;
            </p>
        </div>
        <div class="offset-top-30">
            <p class="privacy-policy_list_item">
                W celu ustalenia, dochodzenia lub obrony przed roszczeniami
                przetwarzamy takie dane osobowe, jak:
            </p>
            <ul>
                <li>
                    imię i nazwisko (jeżeli nazwisko zostało podane) lub
                    ewentualnie firmę,
                </li>
                <li>imię dziecka,</li>
                <li>adres zamieszkania (jeżeli został podany),</li>
                <li>numer PESEL lub numer NIP (jeżeli został podany),</li>
                <li>adres e-mail,</li>
                <li>
                    ewentualnie adres zamieszkania — jeżeli nastąpił zwrot
                    pieniędzy w ramach reklamacji,
                </li>
                <li>
                    ewentualnie numer rachunku bankowego — jeżeli nastąpił zwrot
                    pieniędzy w ramach reklamacji
                </li>
            </ul>
            <p class="privacy-policy_list_item">
                Podstawą prawną takiego przetwarzania danych jest art. 6 ust. 1
                lit. f RODO, który pozwala przetwarzać dane osobowe, jeżeli tym
                sposobem Administrator Danych Osobowych realizuje swój prawnie
                uzasadniony interes (w tym przypadku interesem Novakid jest
                posiadanie danych osobowych, które pozwolą ustalić, dochodzić
                lub bronić się przed roszczeniami, w tym klientów i osób
                trzecich);
            </p>
            <p class="privacy-policy_list_item">jak też:</p>
            <ul>
                <li>wizerunek dziecka</li>
                <li>wizerunek rodzica</li>
            </ul>
            <p class="privacy-policy_list_item">
                Podstawą prawną takiego przetwarzania danych jest art. 9 ust. 2
                lit. f RODO, który pozwala przetwarzać dane osobowe, które
                ujawniają pochodzenie rasowe lub etniczne, jeżeli przetwarzanie
                jest niezbędne do ustalenia, dochodzenia, obrony roszczeń lub w
                ramach sprawowania wymiaru sprawiedliwości przez sądy.
            </p>
        </div>
        <div class="offset-top-30">
            <p class="privacy-policy_list_item">
                W celu archiwalnym i dowodowym przetwarzamy takie dane osobowe,
                jak:
            </p>
            <ul>
                <li>imię i nazwisko (jeżeli zostało podane),</li>
                <li>adres e-mail,</li>
            </ul>
            <p class="privacy-policy_list_item">
                — na potrzeby zabezpieczenia informacji, które mogą służyć
                wykazywaniu faktów o znaczeniu prawnym. Podstawą prawną takiego
                przetwarzania danych jest art. 6 ust. 1 lit. f RODO, który
                pozwala przetwarzać dane osobowe, jeżeli tym sposobem
                Administrator Danych Osobowych realizuje swój prawnie
                uzasadniony interes (w tym przypadku interesem Novakid jest
                posiadanie danych osobowych, które pozwolą dowieść pewnych
                faktów związanych z realizacją usług, np. gdy jakiś organ
                państwowy tego zażąda);
            </p>
        </div>
        <div class="offset-top-30">
            <p class="privacy-policy_list_item">
                W celu analitycznym, tj. badania i analizowania aktywności na
                stronie internetowej należącej do Novakid, przetwarzamy takie
                dane osobowe, jak:
            </p>
            <ul>
                <li>data i godzina odwiedzin strony,</li>
                <li>rodzaj systemu operacyjnego,</li>
                <li>przybliżona lokalizacja,</li>
                <li>
                    rodzaj przeglądarki internetowej wykorzystywanej do
                    przeglądania strony,
                </li>
                <li>płeć,</li>
                <li>przedział wiekowy,</li>
                <li>czas spędzony na stronie,</li>
                <li>odwiedzone podstrony,</li>
                <li>podstrona, gdzie wypełniono formularz kontaktowy.</li>
            </ul>
            <p class="privacy-policy_list_item">
                Podstawą prawną takiego przetwarzania danych jest art. 6 ust. 1
                lit. f RODO, który pozwala przetwarzać dane osobowe, jeżeli tym
                sposobem Administrator Danych Osobowych realizuje swój prawnie
                uzasadniony interes (w tym przypadku interesem Spółki jest
                poznanie aktywności klientów na stronie internetowej);
            </p>
        </div>
        <div class="offset-top-30">
            <p class="privacy-policy_list_item">
                W celu wykorzystywania cookies na stronie internetowej
                przetwarzamy takie informacje tekstowe.
            </p>
            <p class="privacy-policy_list_item">
                Podstawą prawną takiego przetwarzania jest art. 6 ust. 1 lit. a
                RODO, który pozwala przetwarzać dane osobowe na podstawie
                dobrowolnie udzielonej zgody (przy pierwszym wejściu na stronę
                internetową pojawia się zapytanie o zgodę na wykorzystanie
                cookies);
            </p>
        </div>
        <div class="offset-top-30">
            <p class="privacy-policy_list_item">
                W celu administrowania stroną internetową przetwarzamy takie
                dane osobowe, jak:
            </p>
            <ul>
                <li>adres IP,</li>
                <li>data i czas serwera,</li>
                <li>informacje o przeglądarce internetowej,</li>
                <li>informacje o systemie operacyjnym</li>
            </ul>
            <p class="privacy-policy_list_item">
                — dane te są zapisywane automatycznie w tzw. logach serwera,
                przy każdorazowym korzystaniu ze strony należącej do Novakid.
                Administrowanie stroną internetową bez użycia serwera i bez tego
                automatycznego zapisu nie byłoby możliwe. Podstawą prawną
                takiego przetwarzania danych jest art. 6 ust. 1 lit. f RODO,
                który pozwala przetwarzać dane osobowe, jeżeli tym sposobem
                Administrator Danych Osobowych realizuje swój prawnie
                uzasadniony interes (w tym przypadku interesem Spółki jest
                administrowanie stroną internetową);
            </p>
        </div>
        <div class="offset-top-40">
            <h6 class="privacy-policy_list_title text-bold">IV. Cookies</h6>
            <p class="privacy-policy_list_item">
                1. Novakid na swojej stronie internetowej, podobnie jak inne
                podmioty, wykorzystuje tzw. cookies, czyli krótkie informacje
                tekstowe, zapisywane na komputerze, telefonie, tablecie, czy też
                innym urządzeniu użytkownika. Mogą być one odczytywane przez
                nasz system, a także przez systemy należące do innych podmiotów,
                z których usług korzystamy (np. Facebooka, Google'a).
            </p>
            <p class="privacy-policy_list_item">
                2. Cookies spełniają bardzo wiele funkcji na stronie
                internetowej, najczęściej przydatnych, które postaramy się
                opisać poniżej (jeżeli informacje są niewystarczające, prosimy o
                kontakt):
            </p>
            <ul>
                <li>
                    <strong>zapewnianie bezpieczeństwa</strong>
                    — pliki cookies są wykorzystywane w celu uwierzytelniania
                    użytkowników oraz zapobiegania nieupoważnionemu korzystaniu
                    z panelu klienta. Służą zatem do ochrony danych osobowych
                    użytkownika przed dostępem osób nieupoważnionych;
                </li>
                <li>
                    <strong
                        >wpływ na procesy i wydajność korzystania ze strony
                        internetowej</strong
                    >
                    — pliki cookies są wykorzystywane do tego, aby witryna
                    sprawnie działała i aby można było korzystać z funkcji na
                    niej dostępnych, co jest możliwe między innymi dzięki
                    zapamiętywaniu ustawień pomiędzy kolejnymi odwiedzinami na
                    stronie. Dzięki nim można zatem sprawnie poruszać się na
                    stronie internetowej i poszczególnych podstronach;
                </li>
                <li>
                    <strong>stan sesji</strong>
                    — w plikach cookies często są zapisywane informacje o tym,
                    jak odwiedzający korzystają ze strony internetowej, np.
                    które podstrony najczęściej wyświetlają. Umożliwiają również
                    identyfikację błędów wyświetlanych na niektórych
                    podstronach. Pliki cookies służące do zapisywania tzw.
                    „stanu sesji" pomagają zatem ulepszać usługi i zwiększać
                    komfort przeglądania stron;
                </li>
                <li>
                    <strong>utrzymanie stanu sesji</strong>
                    — jeżeli klient loguje się do swojego panelu, to pliki
                    cookies umożliwiają podtrzymanie sesji. Oznacza to, że po
                    przejściu na inną podstronę nie trzeba każdorazowo podawać
                    ponownie loginu i hasła, co sprzyja komfortowi korzystania
                    ze strony internetowej;
                </li>
                <li>
                    <strong>tworzenie statystyk</strong>
                    — pliki cookies są wykorzystywane do tego, aby
                    przeanalizować, w jaki sposób użytkownicy korzystają ze
                    strony internetowej (jak wielu otwiera stronę internetową,
                    jak długo na niej pozostają, które treści wzbudzają
                    największe zainteresowanie etc.). Dzięki temu można stale
                    ulepszać stronę internetową i dostosowywać jej działanie do
                    preferencji użytkowników. W celu śledzenia aktywności i
                    tworzenia statystyk wykorzystujemy narzędzia Google'a, takie
                    jak Google Analytics; oprócz raportowania statystyk
                    użytkowania witryny pikselowy Google Analytics może również
                    służyć, razem z niektórymi opisanymi powyżej plikami
                    cookies, do pomocy w wyświetlaniu użytkownikowi bardziej
                    trafnych treści w usługach Google (np. w wyszukiwarce
                    Google) i w całej sieci;
                </li>
                <li>
                    <strong>korzystanie z funkcji społecznościowych</strong>
                    — na stronie internetowej posiadamy tzw. pixel Facebooka,
                    który umożliwia polubienie naszego fanpage'a w tym serwisie
                    podczas korzystania z witryny. Jednak, aby to było możliwe,
                    musimy korzystać z plików cookies dostarczanych przez
                    Facebooka.
                </li>
            </ul>
            <p class="privacy-policy_list_item">
                3. Co ważne, wiele plików cookies ma dla nas charakter
                zanonimizowany — bez dodatkowych informacji, na ich podstawie
                nie jesteśmy w stanie zidentyfikować Pana/Pani tożsamości.
            </p>
            <p class="privacy-policy_list_item">
                4. Pana/Pani przeglądarka internetowa domyślnie dopuszcza
                wykorzystywanie cookies w Pana/Pani urządzeniu, dlatego przy
                pierwszej wizycie prosimy o wyrażenie zgody na użycie cookies.
                Jeżeli jednak nie życzy Pan/Pani sobie wykorzystania cookies
                przy przeglądaniu strony internetowej, można zmienić ustawienia
                w przeglądarce internetowej — całkowicie blokować automatyczną
                obsługę plików cookies lub żądać powiadomienia o każdorazowym
                zamieszczeniu cookies w urządzeniu. Ustawienia można zmienić w
                dowolnej chwili.
            </p>
            <p class="privacy-policy_list_item">
                5. Szanując autonomię wszystkich osób korzystających ze strony
                internetowej, czujemy się jednak w obowiązku uprzedzić, że
                wyłączenie lub ograniczenie obsługi plików cookies może
                spowodować dość poważne trudności w korzystaniu ze strony
                internetowej, np. w postaci konieczności logowania się na każdej
                podstronie, dłuższego okresu ładowania się strony, ograniczeń w
                korzystaniu z funkcjonalności, ograniczeń w polubieniu strony na
                Facebooku etc.
            </p>
        </div>
        <div class="offset-top-40">
            <h6 class="privacy-policy_list_title text-bold">
                V. Prawo wycofania zgody
            </h6>
            <p class="privacy-policy_list_item">
                1. Jeżeli przetwarzanie danych osobowych odbywa się na podstawie
                zgody, w każdej chwili może Pan/Pani tę zgodę cofnąć — wedle
                własnego uznania.
            </p>
            <p class="privacy-policy_list_item">
                2. Jeżeli chciałby/chciałaby Pan/Pani cofnąć zgodę na
                przetwarzanie danych osobowych, to w tym celu wystarczy wysłać
                maila bezpośrednio do Novakid na adres bok@novakid.pl.
            </p>
            <p class="privacy-policy_list_item">
                3. Jeżeli przetwarzanie Pana/Pani danych osobowych odbywało się
                na podstawie zgody, jej cofnięcie nie powoduje, że przetwarzanie
                danych osobowych do tego momentu było nielegalne. Innymi słowy,
                do czasu cofnięcia zgody mamy prawo przetwarzać Pana/Pani dane
                osobowe i jej odwołanie nie wpływa na zgodność z prawem
                dotychczasowego przetwarzania.
            </p>
        </div>
        <div class="offset-top-40">
            <h6 class="privacy-policy_list_title text-bold">
                VI. Wymóg podania danych osobowych
            </h6>
            <p class="privacy-policy_list_item">
                1. Podanie jakichkolwiek danych osobowych jest dobrowolne i
                zależy od Pana/Pani decyzji. Jednakże w niektórych przypadkach
                podanie określonych danych osobowych jest konieczne, aby spełnić
                Pana/Pani oczekiwania w zakresie korzystania z usług Novakid.
            </p>
            <p class="privacy-policy_list_item">
                2. Aby zlecić usługę w Novakid, konieczne jest podanie imienia,
                numeru telefonu, adresu e-mail, imienia dziecka oraz wieku
                dziecka oraz udzielenie zgody na przetwarzanie wizerunku swojego
                oraz dziecka— bez tego nie jesteśmy w stanie zawrzeć i wykonać
                umowy, w szczególności bez zgody na przetwarzanie wizerunku nasi
                lektorzy nie mogliby w sposób zdalny prowadzić lekcji, tj. przy
                użyciu środków komunikacji na odległość, które umożliwiają
                jednoczesne przesyłanie obrazu, jak i dźwięku.
            </p>
            <p class="privacy-policy_list_item">
                3. Aby mógł/mogła Pan/Pani otrzymać fakturę za usługi, konieczne
                jest podanie wszystkich danych wymaganych prawem podatkowym, a
                zatem imienia i nazwiska lub firmy, adresu zamieszkania lub
                adresu siedziby, numeru NIP — bez tego nie jesteśmy w stanie
                prawidłowo wystawić faktury.
            </p>
            <p class="privacy-policy_list_item">
                4. Aby móc się skontaktować z Panem/Panią telefonicznie w
                sprawach związanych z realizacją usługi, konieczne jest podanie
                numeru telefonu — bez tego nie jesteśmy w stanie nawiązać
                kontaktu telefonicznego.
            </p>
            <p class="privacy-policy_list_item">
                5. Aby móc skontaktować się z Panem/Panią poprzez wiadomość
                e-mail w sprawach związanych z rozpatrywanie reklamacji,
                konieczne jest podanie adresu e-mail – bez tego nie jesteśmy w
                stanie rozpatrzyć reklamacji.
            </p>
            <p class="privacy-policy_list_item">
                6. Jeżeli życzy sobie Pan/Pani otrzymywać powiadomienia smsem o
                komunikatach w panelu klienta, konieczne jest podanie numeru
                telefonu — bez tego nie jesteśmy w stanie przesyłać wiadomości.
            </p>
        </div>
        <div class="offset-top-40">
            <h6 class="privacy-policy_list_title text-bold">
                VII. Zautomatyzowane podejmowanie decyzji i profilowanie
            </h6>
            <p class="privacy-policy_list_item">
                Uprzejmie informujemy, że nie dokonujemy zautomatyzowanego
                podejmowania decyzji, w tym w oparciu o profilowanie.
            </p>
        </div>
        <div class="offset-top-40">
            <h6 class="privacy-policy_list_title text-bold">
                VIII. Odbiorcy danych osobowych
            </h6>
            <p class="privacy-policy_list_item">
                1. Jak większość przedsiębiorców, w swojej działalności
                korzystamy z pomocy innych podmiotów, co niejednokrotnie wiąże
                się z koniecznością przekazania danych osobowych. W związku z
                powyższym, w razie potrzeby, przekazujemy Pana/Pani dane osobowe
                współpracującym z nami lektorom, prawnikom, którzy realizują
                usługi, firmie księgowej, firmie hostingowej, firmie
                odpowiedzialnej za wysyłanie komunikatów sms oraz świadczącej
                usługę telefonii VoIP , a także firmie obsługującej nasz system
                pocztowy.
            </p>
            <p class="privacy-policy_list_item">
                2. Oprócz tego, może się zdarzyć, że np. na podstawie właściwego
                przepisu prawa lub decyzji właściwego organu będziemy musieli
                przekazać Pana/Pani dane osobowe również innym podmiotom, czy to
                publicznym czy prywatnym. Dlatego niezmiernie trudno nam
                przewidzieć, kto może zgłosić się z żądaniem udostępnienia
                danych osobowych. Niemniej ze swojej strony zapewniamy, że każdy
                przypadek żądania udostępnienia danych osobowych analizujemy
                bardzo starannie i bardzo wnikliwie, aby niechcący nie przekazać
                informacji osobie nieuprawnionej.
            </p>
        </div>
        <div class="offset-top-40">
            <h6 class="privacy-policy_list_title text-bold">
                IX. Przekazywanie danych osobowych do państw trzecich
            </h6>
            <p class="privacy-policy_list_item">
                1. Nasza firma prowadzi działalność na terenie Rzeczpospolitej,
                jednak poza jednostką organizacyjną na ternie Unii Europejskiej
                Państwa obsługą od strony technicznej oraz administracyjnej
                zajmują się także nasi pracownicy z jednostek organizacyjnych na
                terenie Federacji Rosyjskiej. W związku z powyższym na ternie
                tego Państwa również przetwarzamy powierzane nam dane osobowe. W
                świetle przepisów RODO państwo to jest traktowane jako państwo
                trzecie.
            </p>
            <p class="privacy-policy_list_item">
                2. Jak większość przedsiębiorców, korzystamy również z różnych
                popularnych usług i technologii, oferowanych przez takie
                podmioty, jak Facebook, Microsoft, Google, Intercom.io.
                Współpracujemy również z lektorami, którzy przebywają poza
                terytorium Unii Europejskiej. Podmioty te świadcząc na naszą
                rzecz usługi przetwarzają Państwa dane osobowe poza Unią
                Europejską, a więc w świetle przepisów RODO również są
                traktowane jako państwa trzecie.
            </p>
            <p class="privacy-policy_list_item">
                3 .RODO wprowadza pewne ograniczenia w przekazywaniu danych
                osobowych do państw trzecich, ponieważ skoro nie stosuje się
                tam, co do zasady przepisów europejskich, ochrona danych
                osobowych obywateli Unii Europejskiej może być niestety
                niewystarczająca. Dlatego też każdy administrator danych
                osobowych ma obowiązek ustalić podstawę prawną takiego
                przekazywania.
            </p>
            <p class="privacy-policy_list_item">
                4. Ze swojej strony zapewniamy, że przetwarzanie Państwa danych
                osobowych przez naszych pracowników na terenie Federacji
                Rosyjskiej w pełni odpowiada gwarancjom i wymogom stawianym
                przez rozporządzenie Parlamentu Europejskiego i Rady (UE)
                2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób
                fizycznych w związku z przestrzeganiem danych osobowych i w
                sprawie swobodnego przepływu takich danych oraz uchylenia
                dyrektywy 95/46/WE (dalej RODO). Dodatkowo, z uwagi, że w
                odniesieniu do tego państwa Komisja Europejska nie stwierdziła
                odpowiedniego poziomu ochrony danych osobowych, będziemy
                stosowali środki rekompensujące brak ochrony danych poprzez
                odpowiednie zabezpieczenie Pani/Pana danych osobowych za pomocą
                standardowych klauzul ochrony danych przyjętych przez Komisję
                Europejską w decyzji z dnia 15 czerwca 2001 r. numer 2001/497/WE
                w sprawie standardowych klauzul umownych w związku z
                przekazywaniem danych osobowych do państw trzecich na podstawie
                Dyrektywy 95/46/WE Parlamentu Europejskiego i Rady z dnia 24
                października 1995 r. w sprawie ochrony osób fizycznych w
                zakresie przetwarzania danych osobowych oraz swobodnego
                przepływu tych danych (Dz. Urz. WE L 181/19, z 4.07.2001).
                Klauzule te zostały wprowadzone do naszego Regulaminu.
            </p>
            <p class="privacy-policy_list_item">
                5. Przy korzystaniu z usług i technologii przekazujemy dane
                osobowe podmiotom ze Stanów Zjednoczonych, lecz wyłącznie takim,
                które przystąpiły do programu Privacy Shield, na podstawie
                decyzji wykonawczej Komisji Europejskiej z dnia 12 lipca 2016 r.
                — więcej na ten temat można przeczytać na stronie Komisji
                Europejskiej dostępnej pod adresem
                https://ec.europa.eu/info/law/law-topic/data-protection/data-transfers-outside-eu/eu-us-privacy-shield_pl.
                Podmioty, które przystąpiły do programu Privacy Shield,
                gwarantują, że będą przestrzegać wysokich standardów w zakresie
                ochrony danych osobowych, jakie obowiązują w Unii Europejskiej,
                dlatego korzystanie z ich usług i oferowanych technologii w
                procesie przetwarzania danych osobowych jest zgodne z prawem.
            </p>
            <p class="privacy-policy_list_item">
                6. Jako, że współpracujemy z lektorami, którzy przebywają poza
                terytorium Unii Europejskiej i w stosunku do tych Państw Komisja
                Europejska nie stwierdziła odpowiedniego poziomu ochrony danych
                osobowych, będziemy stosowali środki rekompensujące brak ochrony
                danych poprzez odpowiednie zabezpieczenie Pani/Pana danych
                osobowych za pomocą standardowych klauzul ochrony danych
                przyjętych przez Komisję Europejską w decyzji z dnia 5 lutego
                2010 r. numer 2010/87/UE w sprawie standardowych klauzul
                umownych dotyczących przekazywania danych osobowych podmiotom
                przetwarzającym dane mającym siedzibę w krajach trzecich na mocy
                Dyrektywy 95/46/WE Parlamentu Europejskiego i Rady z dnia 24
                października 1995 r. w sprawie ochrony osób fizycznych w
                zakresie przetwarzania danych osobowych oraz swobodnego
                przepływu tych danych (Dz. Urz. WE L 181/19, z 4.07.2001).
                Klauzule te zostały wprowadzone do umów o powierzenie
                przetwarzania Państwa danych osobowych zawartych z lektorami.
                Może Pan/Pani domagać się od administratora danych wykonania
                uprawnień, które przysługują mu na mocy powyższych umów względem
                podmiotu przetwarzającego jakim jest lektor, jako osoba trzecia
                na rzecz której zawarto umowę. Na Pana/Pani żądanie udostępnimy
                kopię niniejszych klauzul oraz skrócony opis środków
                bezpieczeństwa, a także kopię każdej umowy o powierzenie
                przetwarzania danych, która musi być zawarta zgodnie z
                niniejszymi klauzulami (z wyjątkiem części dotyczących
                informacji handlowych). Przysługuje Panu/Pani również prawo do
                uzyskania odszkodowania, zarówno od nas jako administratora
                danych, jak też lektorów, którzy na nasze zlecenie przetwarzają
                Pana/Pani dane osobowe, gdy z powodu naruszenia obowiązków
                wynikających z ww. umowy powierzenia przetwarzania danych doszło
                do powstania szkody.
            </p>
            <p class="privacy-policy_list_item">
                7. W każdej chwili udzielimy Panu/Pani dodatkowych wyjaśnień
                odnośnie przekazywania danych osobowych, w szczególności, gdy
                kwestia ta budzi Pana/Pani niepokój.
            </p>
        </div>
        <div class="offset-top-40">
            <h6 class="privacy-policy_list_title text-bold">
                X. Okres przetwarzania danych osobowych
            </h6>
            <p class="privacy-policy_list_item">
                1. Zgodnie z obowiązującymi przepisami prawa nie przetwarzamy
                Pana/Pani danych osobowych „w nieskończoność", lecz przez czas,
                który jest potrzebny, aby osiągnąć wyznaczony cel. Po tym
                okresie Pana/Pani dane osobowe zostaną nieodwracalnie usunięte
                lub zniszczone.
            </p>
            <p class="privacy-policy_list_item">
                2. W sytuacji, gdy nie potrzebujemy wykonywać innych operacji na
                Pana/Pani danych osobowych niż ich przechowywanie (np. gdy
                przechowujemy nagranie lekcji lub korespondencję e-mail na
                potrzeby obrony przed roszczeniami), do momentu trwałego
                usunięcia lub zniszczenia dodatkowo je zabezpieczamy — poprzez
                pseudonimizację. Pseudonimizacja polega na takim zaszyfrowaniu
                danych osobowych, czy też zbioru danych osobowych, że bez
                dodatkowego klucza nie da się ich odczytać, a zatem takie
                informacje stają się całkowicie bezużyteczne dla osoby
                nieuprawnionej.
            </p>
            <p class="privacy-policy_list_item">
                3. Odnośnie poszczególnych okresów przetwarzania danych
                osobowych, uprzejmie informujemy, że dane osobowe przetwarzamy
                przez okres:
            </p>
            <ul>
                <li>
                    trwania umowy — w odniesieniu do danych osobowych
                    przetwarzanych w celu zawarcia i wykonania umowy;
                </li>
                <li>
                    6 lat + 1 rok — w odniesieniu do danych osobowych
                    przetwarzanych w celu ustalenia, dochodzenia lub obrony
                    roszczeń;
                </li>
                <li>
                    6 miesięcy — w odniesieniu do danych osobowych, które
                    zostały zebrane w celu założenia Konta, a jednocześnie nie
                    doszło do niezwłocznego zawarcia umowy;
                </li>
                <li>
                    do czasu skutecznego wniesienia sprzeciwu lub osiągnięcia
                    celu przetwarzania, jednak nie dłużej niż przez 5 lat — w
                    odniesieniu do danych osobowych przetwarzanych na podstawie
                    prawnie uzasadnionego interesu Administratora Danych
                    Osobowych;
                </li>
                <li>
                    do czasu zdezaktualizowania się lub utraty przydatności,
                    jednak nie dłużej niż przez 3 lata — w odniesieniu do danych
                    osobowych przetwarzanych głównie do celów analitycznych,
                    wykorzystania cookies i administrowania stroną internetową.
                </li>
            </ul>
            <p class="privacy-policy_list_item">
                4. Okresy w latach liczymy od końca roku, w którym rozpoczęliśmy
                przetwarzanie danych osobowych, aby usprawnić proces usuwania
                lub niszczenia danych osobowych. Odrębne liczenie terminu dla
                każdej zawartej umowy wiązałoby się z istotnymi trudnościami
                organizacyjnymi i technicznymi, jak również znaczącym nakładem
                finansowym, dlatego ustanowienie jednej daty usuwania lub
                niszczenia danych osobowych pozwala nam sprawniej zarządzać tych
                procesem. Oczywiście, w przypadku skorzystania przez Pana/Panią
                z prawa do zapomnienia takie sytuacje są rozpatrywane
                indywidualnie.
            </p>
            <p class="privacy-policy_list_item">
                5. Dodatkowy rok związany z przetwarzaniem danych osobowych
                zebranych na potrzeby wykonania umowy jest podyktowany tym, że
                hipotetycznie może Pan/Pani zgłosić roszczenie na chwilę przed
                upływem terminu przedawnienia, żądanie może zostać doręczone z
                istotnym opóźnieniem lub może Pan/Pani błędnie określić termin
                przedawnienia swojego roszczenia.
            </p>
            <p class="privacy-policy_list_item">
                6. Okresy w latach liczymy od końca roku, w którym rozpoczęliśmy
                przetwarzanie danych osobowych, aby usprawnić proces usuwania
                lub niszczenia danych osobowych. Odrębne liczenie terminu dla
                każdego zdarzenia wiązałoby się z istotnymi trudnościami
                organizacyjnymi i technicznymi, jak również znaczącym nakładem
                finansowym, dlatego ustanowienie jednej daty usuwania lub
                niszczenia danych osobowych pozwala nam sprawniej zarządzać tych
                procesem. Oczywiście, w przypadku skorzystania przez Pana/Panią
                z prawa do zapomnienia takie sytuacje są rozpatrywane
                indywidualnie.
            </p>
        </div>
        <div class="offset-top-40">
            <h6 class="privacy-policy_list_title text-bold">
                XI. Uprawnienia podmiotów danych
            </h6>
            <p class="privacy-policy_list_item">
                1. Uprzejmie informujemy, że posiada Pan/Pani prawo do:
            </p>
            <ul>
                <li>dostępu do swoich danych osobowych;</li>
                <li>sprostowania danych osobowych;</li>
                <li>usunięcia danych osobowych;</li>
                <li>ograniczenia przetwarzania danych osobowych;</li>
                <li>sprzeciwu wobec przetwarzania danych osobowych;</li>
                <li>przenoszenia danych osobowych.</li>
            </ul>
            <p class="privacy-policy_list_item">
                2. Szanujemy Pana/Pani prawa wynikające z przepisów o ochronie
                danych osobowych i staramy się ułatwiać ich realizację w
                najwyższym możliwym stopniu.
            </p>
            <p class="privacy-policy_list_item">
                3. Wskazujemy, że wymienione uprawnienia nie mają charakteru
                absolutnego, a zatem w niektórych sytuacjach możemy zgodnie z
                prawem odmówić Panu/Pani ich spełnienia. Jednakże, jeżeli
                odmawiamy uwzględnienia żądania, to tylko po wnikliwej analizie
                i tylko w sytuacji, gdy odmowa uwzględnienia żądania jest
                konieczna.
            </p>
            <p class="privacy-policy_list_item">
                4. Odnośnie prawa do wniesienia sprzeciwu wyjaśniamy, że w
                każdej chwili przysługuje Panu/Pani prawo do sprzeciwienia się
                przetwarzaniu danych osobowych na podstawie prawnie
                uzasadnionego interesu Administratora Danych Osobowych (zostały
                one wymienione w punkcie III) w związku z Pana/Pani szczególną
                sytuacją. Musi Pan/Pani jednak pamiętać, że zgodnie z przepisami
                możemy odmówić uwzględnienia sprzeciwu, jeżeli wykażemy, że:
            </p>
            <ul>
                <li>
                    istnieją prawnie uzasadnione podstawy do przetwarzania,
                    które są nadrzędne w stosunku do Pana/Pani interesów, praw i
                    wolności lub
                </li>
                <li>
                    istnieją podstawy do ustalenia, dochodzenia lub obrony
                    roszczeń.
                </li>
            </ul>
            <p class="privacy-policy_list_item">
                5. Swoje uprawnienia może Pan/Pani zrealizować poprzez:
            </p>
            <ul>
                <li>
                    wysłanie maila bezpośrednio do Novakid na adres
                    bok@novakid.pl lub
                </li>
                <li>
                    kontakt telefoniczny z Novakid pod numerem telefonu
                    +48223906433.
                </li>
            </ul>
        </div>
        <div class="offset-top-40">
            <h6 class="privacy-policy_list_title text-bold">
                XII. Prawo do wniesienia skargi
            </h6>
            <p class="privacy-policy_list_item">
                Jeżeli uważa Pan/Pani, że Pana/Pani dane osobowe są przetwarzane
                niezgodnie z obowiązującym prawem, może Pan/Pani wnieść skargę
                do Prezesa Urzędu Ochrony Danych Osobowych.
            </p>
        </div>
        <div class="offset-top-40">
            <h6 class="privacy-policy_list_title text-bold">
                XIII. Postanowienia końcowe
            </h6>
            <p class="privacy-policy_list_item">
                1. W zakresie nieuregulowanym niniejszą Polityką prywatności
                obowiązują przepisy z zakresu ochrony danych osobowych.
            </p>
            <p class="privacy-policy_list_item">
                2. O wszelkich zmianach wprowadzonych do niniejszej Polityki
                prywatności zostanie Pan/Pani powiadomiony/powiadomiona drogą
                elektroniczną na podany adres e-mail .
            </p>
            <p class="privacy-policy_list_item">
                3. Niniejsza Polityka prywatności obowiązuje od dnia 25.05.2018
                r.
            </p>
        </div>
    </div>
</template>
<script>
export default {}
</script>
